import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ChangePasswordForm extends BaseComponent {
	
	static get properties() {
		return {			
			showcancel: {type: String}
		};
	}
	
	constructor() {
		super();
						
		var passwordForm = this;
		setTimeout(function(){
			passwordForm.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var passwordForm = this;
		
		Service.getUserService().getCurrentUser().then(function(currentUser){
			
			if (currentUser.ssoUser) {
				
				var resetContainer = ElementUtil.create({
					tag: 'div',
					style: 'text-align: center;',
					children: [
						{
							tag: 'div',
							innerHTML: 'Click below to receive a secure password reset email from our SSO service.'
						},
						{
							tag: 'vaadin-button',
							children:[
								ElementUtil.makeIcon('vaadin:rotate-right', ' Request Password Change')
							], 
							listeners: {
								click: function() {

									window.DL.MessageUtil.showConfirm({
										title: 'Request a password reset?',
										message: 'To proceed, we need to send a reset link to your registered email address.',
										buttons: [
											{
												text: 'Request Reset',
												handler: function() {
													var loadMask = grid.showLoading('Requesting Reset...');													

													Service.getUserService().updatePasswordCurrentUser({}).then(function(){
														loadMask.remove();
														window.DL.MessageUtil.showToast('Request Submitted', 'Check your inbox for an email with password reset instructions.', {									
															theme: 'success'
														});												

														var customEvent = new CustomEvent('reset-password', { detail: '' });
														passwordForm.dispatchEvent(customEvent);
													});															

												}	
											},
											{
												text: 'Cancel'
											}
										]
									});	
								}
							}							
						}
					]
				});
				
				passwordForm.append(resetContainer);
			} else {
				passwordForm.formPanel = ElementUtil.create({
					tag: 'dl-form-panel',
					style: passwordForm.style.cssText ? passwordForm.style.cssText : '',
					itemid: 'form',
					children: [
						{
							tag: 'vaadin-form-layout',										
							children: [						
								{
									tag: 'vaadin-password-field',
									name: 'oldPassword',
									label: 'Old Password',
									required: true,
									maxlength: 80
								},
								{
									tag: 'vaadin-password-field',
									name: 'newPassword',
									label: 'New Password',
									required: true,
									maxlength: 80
								},
								{
									tag: 'vaadin-password-field',
									name: 'confirmPassword',
									label: 'Confirm Password',
									required: true,
									maxlength: 80
								},
								{
									tag: 'hr',
									colspan: 2
								},
								{
									tag: 'div',
									style: 'text-align: center;',
									colspan: 2,
									defaults: {
										tag: 'vaadin-button'
									},
									children: [
										{
											theme: 'primary',
											children: [
												ElementUtil.makeIcon('vaadin:database', ' Update Password')
											],
											listeners: {
												click: function() {
													if (passwordForm.formPanel.isValid()) {
														var data = passwordForm.formPanel.getData();

														if (data.newPassword !== data.confirmPassword) {
															window.DL.MessageUtil.showOkMessage('New Password and Confirm Password need to be the same.');													
														} else {

															passwordForm.formPanel.submitForm({												
																actualCall: function(data) {
																	return Service.getUserService().updatePasswordCurrentUser(data);
																},
																success: function(data, responseData) {													
																	window.DL.MessageUtil.showToast('Success', 'Updated Password', {									
																		theme: 'success',
																		position: 'top-stretch'
																	});

																	var actionEvent = new CustomEvent('saved', { detail: responseData });
																	passwordForm.dispatchEvent(actionEvent);

																	passwordForm.formPanel.clearFields();
																}
															});

														}
													}	
												}
											}
										},
										{
											theme: 'tertiary',
											innerHTML: 'Cancel',
											style: 'margin-left: 10px;',
											'class': passwordForm.showcancel ? '' : 'hide',
											listeners: {
												click: function() {
													var actionEvent = new CustomEvent('cancel', { detail: '' });
													passwordForm.dispatchEvent(actionEvent);
												}
											}
										}
									]
								}
							]
						}
					]
				});

				passwordForm.append(passwordForm.formPanel);
			}			
		});
		
	}
	
};
customElements.define('dl-changepassword-form', ChangePasswordForm);


